import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { DocumentComponent }  from './document.component';
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import {SharedModule} from "app/modules/shared/shared.module";

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        NWMControls,
        NgbModule,
        SharedModule,
        DocumentComponent
    ],
    providers: [
        DatePipe
    ]
})
export class DocumentModule{}
